
import React from 'react';
import { useLang } from '@/contexts/LangContext';
import { Quote } from 'lucide-react';

const TestimonialsSection = () => {
  const { t } = useLang();
  
  const testimonials = [
    {
      quote: t.testimonials.testimonial1.quote,
      author: t.testimonials.testimonial1.author,
      location: t.testimonials.testimonial1.location,
      strategy: t.testimonials.testimonial1.strategy
    },
    {
      quote: t.testimonials.testimonial2.quote,
      author: t.testimonials.testimonial2.author,
      location: t.testimonials.testimonial2.location,
      strategy: t.testimonials.testimonial2.strategy
    },
    {
      quote: t.testimonials.testimonial3.quote,
      author: t.testimonials.testimonial3.author,
      location: t.testimonials.testimonial3.location,
      strategy: t.testimonials.testimonial3.strategy
    }
  ];

  return (
    <div className="py-16 px-4 bg-black">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-2" style={{ color: '#2fb8f8' }}>
          {t.testimonials.title}
        </h2>
        <p className="text-center text-gray-300 mb-12">
          {t.testimonials.subtitle}
        </p>
        
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-gray-900 border border-gray-800 rounded-lg p-6 relative"
            >
              <Quote 
                size={42} 
                className="text-gray-700 absolute top-4 left-4 opacity-20"
              />
              <div className="pl-5 relative">
                <p className="text-gray-300 mb-6 italic">"{testimonial.quote}"</p>
                <div className="border-t border-gray-800 pt-4">
                  <p className="text-white font-bold">{testimonial.author}</p>
                  <p className="text-gray-400 text-sm">{testimonial.location}</p>
                  <p className="text-blue-400 text-sm mt-2">{testimonial.strategy}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialsSection;
